import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { LiaBarsSolid } from "react-icons/lia";
import { RxCross2 } from "react-icons/rx";
import Aos from 'aos';
import 'aos/dist/aos.css';

import Logo from '../ui/Logo';
import LanguageSwitcher from '../ui/LanguageSwitcher';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { navLinks } from '../../constants/data';
import MobileNavbar from './MobileNavbar';
import { AnimatePresence, motion } from 'framer-motion';
import Notifications from './Notifications';
import { fetchNumberOfUnreadNotifications, markAllNotificationsRead } from '../../features/auth/userSlice';


export interface LinkType {
    name_en: string;
    name_ar: string;
    path: string;
}

const Navbar = () => {
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [showNotification, setShowNotifications] = useState<boolean>(false)
    const dispatch = useDispatch<AppDispatch>();
    const { user, notificationCount } = useSelector((state: RootState) => state.user);
    useEffect(() => {
        Aos.init({ duration: 800, easing: 'ease-in-out' });
        if (user) {
            dispatch(fetchNumberOfUnreadNotifications(user?.id))
        }

        const handleScroll = () => {
            setIsScrolled(window.scrollY >= window.innerHeight / 10);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [dispatch, user]);



    return (
        <div className={`w-full text-white  xs:padding-container z-50 transition-all duration-300 bg-primary`}>
            <div className={`flex-between  px-5 py-4 `}>
                <div className="w-32">
                    <Logo color='white' />
                </div>

                <ul className="xs:hidden md:flex-center gap-5 text-lg">
                    {navLinks.map((pageLink: LinkType, index: number) => (
                        <li key={index} className="relative text-nowrap">
                            <NavLink
                                to={pageLink.path}
                                className={({ isActive }) =>
                                    `focus:outline-none text-xl  transition-all hover:text-white ${isActive ? 'text-white' : "text-grayColor"
                                    }`
                                }
                            >
                                {i18n.language === "ar" ? pageLink.name_ar : pageLink.name_en}
                            </NavLink>
                        </li>
                    ))}
                </ul>

                {/* Right Actions */}
                <div className="flex-center xs:gap-2 sm:gap-4">
                    <div className=' flex-center xs:gap-2 sm:gap-4 xs:text-sm sm:text-base'>
                        <div className=' flex-center mt-2'>
                            <LanguageSwitcher />
                        </div>

                        <span>|</span>
                        <p>{user?.currencyCode}</p>
                    </div>


                    {user ? (
                        <div className=' flex gap-1'>
                            <button className='w-6  sm:block relative' onClick={() => {
                                setShowNotifications(true)
                                dispatch(markAllNotificationsRead(user?.id))
                                dispatch(fetchNumberOfUnreadNotifications(user?.id))
                            }

                            } >
                                <img src="/asset/bell.png" className="w-full" alt="user-image" />
                               {notificationCount>0 &&<p className=" absolute top-0 left-0 bg-red-500  w-[14px] h-[14px] text-xs rounded-full flex-center">{notificationCount}</p>}
                            </button>
                            <Link className='w-6  sm:block' to={"/favorite"} ><img src="/asset/heart.png" className="w-full" alt="user-image" /></Link>
                            <Link to={`/me`} className="relative w-6 rounded-full overflow-hidden">
                                <img src="/asset/user-2.png" className="w-full" alt="user-image" />
                            </Link>
                        </div>

                    ) : (
                        <div className=' flex-center gap-3'>
                            <Link
                                to="auth/login"
                                className={`xs:hidden sm:block ${isScrolled ? "text-black" : "text-white"}py-2 px-2 `}
                            >
                                {t("signup")}
                            </Link>
                            <Link
                                to="auth/login"
                                className="xs:hidden sm:block text-white py-2 px-2 rounded-lg transition-all bg-secondry duration-300"
                            >
                                {t("login")}
                            </Link>
                        </div>

                    )}

                    <button
                        onClick={() => setOpen(!open)}
                        className={`xs:block sm:hidden text-xl ${isScrolled ? 'text-black' : 'text-white'}`}
                    >
                        {open ? <RxCross2 /> : <LiaBarsSolid />}
                    </button>
                </div>
            </div>

            {/* Mobile Navbar */}

            <div className={` transition-all h-screen fixed left-0   z-50 overflow-hidden top-0   ${open ? "  w-4/5 " : "w-0"}`}>
                <MobileNavbar open={open} setOpen={setOpen} />
            </div>
            <AnimatePresence>
                {showNotification && (
                    <>
                        {/* الخلفية الشفافة */}
                        <motion.div
                            key="overlay"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.2 }}
                            className="fixed inset-0 bg-black/30 z-40"
                            onClick={() => setShowNotifications(false)}
                        />

                        {/* السلايد نفسه */}
                        <motion.div
                            key="sidebar"
                            initial={{ x: "100%" }}
                            animate={{ x: 0 }}
                            exit={{ x: "100%" }}
                            transition={{ type: "tween", duration: 0.3 }}
                            className="fixed top-0 right-0 h-screen xs:w-full sm:w-96 bg-white shadow-xl z-50 flex flex-col"
                        >
                            <Notifications
                                open={showNotification}
                                setOpen={setShowNotifications}
                            />
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </div>
    );
};

export default Navbar;
